<template>
    <zen-one 
    :showuserinfo="false" 
    title=""
    :crumbs="crumbs"
    >
    <z-page
    title="Saranan Kategori Baka"
    >

    
  
    <w-dialog
      ref="draggableDialog"
      v-model="dialog.show"
      :fullscreen="dialog.fullscreen"
      :width="dialog.width"
      :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
           <div
             class="dialog-title-dragger"
             @mousedown="initDrag"
             style="cursor: move; display: flex; align-items: center;"
           >
             <w-icon class="mr2">fal fa-cog</w-icon>
             {{ dialog.title }}
           </div>
         </template>
  
      <w-form 
        ref="form" 
        v-model="dialog.valid"
      >
      <!-- <w-select :items="lkp_ternakan_id" label="Ternak"  v-model="form.lkp_ternakan_id" @input="getTernakNama()"></w-select> -->
      <z-input label="Kod" v-model="form.kode" name="Kod" :validators="[validators.required]" />
      <z-input label="Nama" v-model="form.nama" name="Nama" :validators="[validators.required]" />
      <z-input label="Keterangan" v-model="form.keterangan" name="Keterangan" :validators="[validators.required]" />
      <!-- <z-input label="Status" v-model="form.status_label" name="Keterangan" /> -->
      <br>
      <template v-if="form.status == 1">
        <w-switch v-model="form.status" label="Aktif" v-if="form.status == 1"/>
      </template>
      <template v-else>
        <w-switch v-model="form.status" label="Tidak Aktif" />
      </template>
      <!-- <w-switch class="mt4" width="col-12" v-model="form.status" label="Status" /> -->
      </w-form>

      
          
  
      
      <template #actions>
        <div class="spacer" />
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
        <w-button 
        class="ml1" 
        :loading="dialog.loading"
        @click="$refs.form.validate()"
        >
          SIMPAN
        </w-button>
      </template>
  
      
    </w-dialog>

    <w-dialog
      v-model="dialog_create.show"
      :fullscreen="dialog_create.fullscreen"
      :width="dialog_create.width"
      :persistent="dialog_create.persistent"
      :persistent-no-animation="dialog_create.persistentNoAnimation"
      title-class="primary-dark1--bg white">
      <template #title>
        <w-icon class="mr2">fal fa-cog</w-icon>
        TAMBAH
      </template>
  
      <w-form 
        ref="form" 
        v-model="dialog_create.valid"
        @validate="submit"
        @success="success"
      >
      <!-- <w-select :items="lkp_ternakan_id" label="Ternak"  v-model="form.lkp_ternakan_id" @input="getTernakNama()"></w-select> -->
      <z-input label="Kod" v-model="form.kode" name="Kod" :validators="[validators.required]" />
      <z-input label="Nama" v-model="form.nama" name="Nama" :validators="[validators.required]" />
      <z-input label="Keterangan" v-model="form.keterangan" name="Keterangan" />
      </w-form>
          
  
      
      <template #actions>
        <div class="spacer" />
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog_create.show = false">TUTUP</w-button>
        <w-button 
        class="ml1" 
        :loading="dialog_create.loading"
        :disabled="dialog_create.valid === false"
        @click="validateAndSubmit"
        >
          SIMPAN
        </w-button>
      </template>
  
      
    </w-dialog>
    
      
          <z-table
            ref="tbluser"
            title="Saranan Kategori Baka"
            :headers="table.headers"  
            :items="table.items"
            :meta="table.meta"
          >
            <template #button>
              <w-button dark class="green--bg ml1" @click="add()">
                <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
              </w-button>
            </template>

            <template #header-label="{ header, label, index }">
              <template v-if="header.key == 'action'">
                Tindakan
              </template>
              <template v-else>
                {{ label }}
              </template>
            </template>

            
            <template #item-cell.keterangan="{ item }">
              <div v-html="item.keterangan.replace(/\n/g, '<br>')"></div>
          </template>

            <template #item-cell.action="{ item }">
              <w-flex class="flex justify-center">
                <w-button class="fs-2 pr3 bs" bg-color="orange-light3" tile @click="edit(item)">
                  <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI
                </w-button>
                &nbsp;  
                <w-button class="fs-2" bg-color="red-light1" dark tile @click="destroy(item)">
                  <w-icon xs class="mr2"> fal fa-trash</w-icon> PADAM
                </w-button>
                &nbsp;
              </w-flex>
            </template>

      </z-table>

  
    </z-page>
    </zen-one>
  </template>
  
  <script>
  import { reactive } from 'vue'
  import ZResource from '@/Modules/z-resource'
  
  export default {
    extends: ZResource,
    props: {
      items: [Array, Object],
    },
    data() {
      return {
        dialog_create: {
            valid: false,
            show: false,
            fullscreen: false,
            persistent: true,
            persistentNoAnimation: false,
            loading: false,
            width: 500,
        },
        resourceurl: 'penyelenggaraan.saranan',
        crumbs: [
          { label: this.$page.props.app_name, route: '/' },
          { label: 'Penyelenggaraan', route: '/penyelenggaraan' },
          { label: 'Saranan Kategori Baka', route: '/penyelenggaraan/saranan' }
        ],
        
        form: {
          id: 0,
          nama: '',
          kode: '',
          keterangan: '',
        }
      }
    },
    methods: {
      add(){
            this.form = {
                id : null,
                kode : null,
                nama : null,
                status : 1,
                keterangan :null,
            }
            this.dialog_create.show = true
            this.dialog.title = 'TAMBAH'
            this.form.saveButton = "Save"
        },
        destroy1(id)
      {
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            this.$zcomm.delete(this.resourceurl + '.destroy',id)
            .then(res => {
              this.sending = false;
              this.$inertia.visit(this.$page.url)
              this.removeitem(res) // remove the data from list. no need to refresh page
              if (typeof this.onAfterDelete === "function") {
                this.onAfterDelete()
              }
            })
            .finally(() => {
              // $('#' + this.resourceurl).modal('hide')
            });
          }else{ }
          })    
  
      },

      initDrag(e) {
     const dialog = this.$refs.draggableDialog?.$el
     const content = dialog?.querySelector('.w-dialog__content')
     if (!content) return

     content.style.position = 'fixed'
     content.style.margin = 0
     content.style.width = dialog.style.width || '500px'
     content.style.zIndex = 1050

     const startX = e.clientX
     const startY = e.clientY
     const rect = content.getBoundingClientRect()
     const origLeft = rect.left
     const origTop = rect.top

     const onMouseMove = (event) => {
       const dx = event.clientX - startX
       const dy = event.clientY - startY
       content.style.left = `${origLeft + dx}px`
       content.style.top = `${origTop + dy}px`
     }

     const onMouseUp = () => {
       document.removeEventListener('mousemove', onMouseMove)
       document.removeEventListener('mouseup', onMouseUp)
     }

     document.addEventListener('mousemove', onMouseMove)
     document.addEventListener('mouseup', onMouseUp)
   },

      async validateAndSubmit() {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.$zutil.notify("Pastikan data sudah terisi", false);
        return
      }
      this.submit()
    },
      
        edit(form){
            this.form = form
            this.dialog.show = true
            this.dialog.title = 'KEMASKINI'
            this.form.saveButton = "Save"
        }
    },
  
    watch: {
  
    },
    mounted() {
      // override default setting
      this.dialog.width = 500
    
        
    },
  }
  </script>
  <style scoped>
.w-dialog {
  position: fixed !important;
}
.draggable-dialog {
  position: fixed !important;
  margin: 0 !important;
  width: 500px !important;
  z-index: 1050;
}

</style>
  